module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homepage"
  }, [(_vm.topNotices && _vm.topNotices.length) ? _c('TopNotice', {
    attrs: {
      "notices": _vm.topNotices
    }
  }) : _vm._e(), _vm._v(" "), (_vm.midNotices && _vm.midNotices.length) ? _c('MidNotice', {
    attrs: {
      "notices": _vm.midNotices
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bannerTexts && _vm.bannerTexts.length) ? _c('div', {
    staticClass: "banner-area"
  }, [_c('BannerTexts', {
    attrs: {
      "bannerTexts": _vm.bannerTexts
    },
    on: {
      "bannerItemClicked": _vm.openCourseDetail
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bannerImgs && _vm.bannerImgs.length) ? _c('div', {
    staticClass: "banner-imgs"
  }, [_c('BannerImages', {
    attrs: {
      "images": _vm.bannerImgs
    },
    on: {
      "bannerItemClicked": _vm.openCourseDetail
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('Modal', {
    attrs: {
      "class-name": "code-detail",
      "width": "550"
    },
    model: {
      value: (_vm.showCodeDetail),
      callback: function($$v) {
        _vm.showCodeDetail = $$v
      },
      expression: "showCodeDetail"
    }
  }, [_c('p', {
    slot: "header"
  }, [_vm._v("验证门票")]), _vm._v(" "), _c('div', {
    staticClass: "code-detail-info"
  }, [_c('h4', {
    staticClass: "code-detail-title"
  }, [_vm._v(_vm._s(_vm.codeItem.dealInfo.poiName) + " | " + _vm._s(_vm.codeItem.dealInfo.ticketTypeName) + " ")]), _vm._v(" "), (_vm.codeItem.orderInfo.orderSource === 4) ? _c('div', {
    staticClass: "from-package-product"
  }, [_c('p', [_vm._v("此订单来自打包产品：" + _vm._s(_vm.codeItem.mainOrderInfo.title))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "price-valid-date"
  }, [_c('label', [_vm._v("购买单价：")]), _vm._v(" "), _c('span', {
    staticClass: "code-detail-money"
  }, [_c('span', {
    staticClass: "unit"
  }, [_vm._v("￥")]), _vm._v(_vm._s(_vm.codeItem.orderInfo.price))]), _vm._v(" "), _c('label', [_vm._v(" 有效期：")]), _vm._v(" "), _c('span', {
    staticClass: "code-detail-validdate"
  }, [_vm._v(_vm._s(_vm.codeItem.voucherInfo.voucherDateBegin) + " 至 " + _vm._s(_vm.codeItem.voucherInfo.voucherDateEnd))])]), _vm._v(" "), (_vm.codeItem.dealInfo.costDetail && _vm.codeItem.dealInfo.costDetail.length) ? _c('div', {
    staticClass: "cost-detail-part"
  }, [_c('h4', {
    staticClass: "cost-detail-title"
  }, [_vm._v("费用包含：")]), _vm._v(" "), _c('ol', {
    staticClass: "cost-details"
  }, _vm._l((_vm.codeItem.dealInfo.costDetail), function(item) {
    return _c('li', {
      key: item
    }, [_vm._v("\n            " + _vm._s(item) + "\n          ")])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "code-use-info"
  }, [_c('label', [_vm._v("查询券号：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.codeFormated(_vm.codeItem)))]), _vm._v(" "), _c('label', [_vm._v("可消费门票：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.codeItem.orderInfo.canUse))])]), _vm._v(" "), _c('div', {
    staticClass: "code-order-info"
  }, [_c('label', [_vm._v("订单号：")]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.openOrderDetail(_vm.codeItem.orderInfo.orderId)
      }
    }
  }, [_vm._v(_vm._s(_vm.codeItem.orderInfo.orderId))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.codeItem.orderInfo.orderSource === 4) ? _c('span', {
    staticClass: "from-package-product"
  }, [_vm._v("(打包订单号：" + _vm._s(_vm.codeItem.mainOrderInfo.orderNo) + ")")]) : _vm._e()]), _vm._v(" "), _c('label', [_vm._v("购买时间：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.codeItem.orderInfo.createDate))])]), _vm._v(" "), (_vm.codeItem.voucherInfo.holder && _vm.codeItem.voucherInfo.holder.length) ? _c('div', {
    staticClass: "voucher-holder"
  }, [_c('ul', _vm._l((_vm.codeItem.voucherInfo.holder), function(item) {
    return _c('li', {
      key: item.dataStr
    }, [_c('label', [_vm._v(_vm._s(_vm.dataMap[item.key]) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.dataStr))])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.codeItem.voucherInfo.credentials && _vm.codeItem.voucherInfo.credentials.length) ? _c('div', {
    staticClass: "credentials-info"
  }, [_c('ul', _vm._l((_vm.codeItem.voucherInfo.credentials), function(person) {
    return _c('li', {
      key: person.credentialsAllInfo
    }, [(person.bookInfo) ? _c('span', [_vm._v("\n              " + _vm._s(person.credentialsAllInfo) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('Button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (person.credentialsAllInfo),
        expression: "person.credentialsAllInfo",
        arg: "copy"
      }],
      key: person.credentialsAllInfo,
      attrs: {
        "type": "primary",
        "size": "small"
      }
    }, [_vm._v("复制")])], 1)
  }))]) : _vm._e(), _vm._v(" "), (_vm.codeItem.orderInfo.canUse) ? _c('div', {
    staticClass: "voucher-code"
  }, [_vm._v("\n        验证\n        "), _c('Select', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.codeCount),
      callback: function($$v) {
        _vm.codeCount = $$v
      },
      expression: "codeCount"
    }
  }, _vm._l((_vm.codeItem.orderInfo.canUse), function(num) {
    return _c('Option', {
      key: num,
      attrs: {
        "value": num
      }
    }, [_vm._v(_vm._s(num))])
  })), _vm._v("张，总价\n        "), _c('span', {
    staticClass: "price"
  }, [_vm._v("￥" + _vm._s(_vm.totalPrice))])], 1) : _vm._e(), _vm._v(" "), (!_vm.codeItem.orderInfo.canUse) ? _c('div', {
    staticClass: "code-no-canuse"
  }, [_vm._v("\n        验证此订单门票均已消费/退款，无法验证\n      ")]) : _vm._e(), _vm._v(" "), (_vm.codeItem.orderInfo.canUse) ? _c('div', {
    staticClass: "verify-btn"
  }, [_c('Button', {
    attrs: {
      "type": "success",
      "disabled": !_vm.codeCount,
      "long": ""
    },
    on: {
      "click": function($event) {
        _vm.verifyCode(false)
      }
    }
  }, [_vm._v("验证")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    slot: "footer"
  })]), _vm._v(" "), _c('Modal', {
    attrs: {
      "class-name": "code-result",
      "width": "550"
    },
    model: {
      value: (_vm.showCodeResult),
      callback: function($$v) {
        _vm.showCodeResult = $$v
      },
      expression: "showCodeResult"
    }
  }, [_c('p', {
    slot: "header"
  }, [_vm._v("验证成功")]), _vm._v(" "), _c('div', {
    staticClass: "code-result-info"
  }, [_c('h4', [_vm._v(_vm._s(_vm.codeItem.dealInfo.poiName) + " | " + _vm._s(_vm.codeItem.dealInfo.ticketTypeName))]), _vm._v(" "), _c('section', {
    staticClass: "code-count-info"
  }, [_c('p', [_vm._v(_vm._s(_vm.codeFormated(_vm.codeItem)) + " * " + _vm._s(_vm.codeCount) + "张")])]), _vm._v(" "), _c('section', {
    staticClass: "code-verify-info"
  }, [_c('p', [_c('label', [_vm._v("订单号：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.codeItem.orderInfo.orderId))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("成功数量：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.codeCount) + "张 * ￥" + _vm._s(_vm.codeItem.orderInfo.price))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("总金额：")]), _vm._v(" "), _c('span', [_vm._v("￥" + _vm._s(_vm.totalPrice))])])]), _vm._v(" "), (_vm.codeItem.dealInfo.costDetail && _vm.codeItem.dealInfo.costDetail.length) ? _c('section', {
    staticClass: "fee-info"
  }, [_c('h4', {
    staticClass: "cost-detail-title"
  }, [_vm._v("费用包含：")]), _vm._v(" "), _c('ol', {
    staticClass: "cost-details"
  }, _vm._l((_vm.codeItem.dealInfo.costDetail), function(item) {
    return _c('li', {
      key: item
    }, [_vm._v("\n            " + _vm._s(item) + "\n          ")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.codeItem.voucherInfo.credentials && _vm.codeItem.voucherInfo.credentials.length) ? _c('section', {
    staticClass: "credentials-info"
  }, [_c('ul', _vm._l((_vm.codeItem.voucherInfo.credentials), function(person) {
    return _c('li', {
      key: person.credentialsAllInfo
    }, [_c('label', [_vm._v("游玩人：")]), _vm._v(" "), (person.credentialsAllInfo) ? _c('span', [_vm._v("\n              " + _vm._s(person.credentialsAllInfo.replace('取票人：', '')) + "\n            ")]) : _vm._e(), _vm._v(" "), (person.credentialsAllInfo) ? _c('Button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (person.credentialsAllInfo),
        expression: "person.credentialsAllInfo",
        arg: "copy"
      }],
      key: person.credentialsAllInfo,
      attrs: {
        "type": "primary",
        "size": "small"
      }
    }, [_vm._v("复制")]) : _vm._e()], 1)
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "success",
      "long": ""
    },
    on: {
      "click": function($event) {
        _vm.closeVerifyResult()
      }
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_c('HomePageCard', {
    staticClass: "verify-card",
    attrs: {
      "title": "美团券验证"
    }
  }, [_c('Input', {
    staticClass: "code-input",
    attrs: {
      "placeholder": "请输入美团券码",
      "maxlength": 14,
      "disabled": _vm.isCodeRequesting,
      "autocomplete": "off",
      "element-id": "ticketHomeVoucherCodeInput"
    },
    on: {
      "on-change": _vm.codeChanged
    },
    model: {
      value: (_vm.code),
      callback: function($$v) {
        _vm.code = $$v
      },
      expression: "code"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isCodeRequesting,
      "disabled": !_vm.code || _vm.isCodeRequesting
    },
    on: {
      "click": _vm.verify
    },
    slot: "append"
  }, [_vm._v("验证")])], 1), _vm._v(" "), _c('div', {
    staticClass: "action-area"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.revokeVerify($event)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "turbo-ui-revoke"
    }
  }), _vm._v("撤销验证")], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.verifyHistory($event)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "turbo-ui-history"
    }
  }), _vm._v("验证历史")], 1)])])], 1), _vm._v(" "), _c('HomePageCard', {
    staticClass: "yesterday-data",
    attrs: {
      "title": "昨日数据",
      "extra": "更多"
    },
    on: {
      "extraClick": function($event) {
        _vm.moreYesterdayData()
      }
    }
  }, [_c('div', {
    staticClass: "data-area"
  }, _vm._l((_vm.yesterdayDatas), function(data) {
    return _c('DataItem', {
      key: data.name,
      attrs: {
        "valueUnit": data.unit,
        "name": data.name,
        "value": data.value,
        "hasCompareValue": true,
        "compareName": "较上周同期",
        "compareValue": data.compareValue
      },
      nativeOn: {
        "click": function($event) {
          _vm.navToDataSummary($event)
        }
      }
    })
  }))])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_c('HomePageCard', {
    staticClass: "yuyue-ticket",
    attrs: {
      "title": "预约票量"
    }
  }, [_c('div', {
    staticClass: "ticket-count"
  }, _vm._l((_vm.orderTicketsData), function(data) {
    return _c('DataItem', {
      key: data.id,
      attrs: {
        "id": data.id,
        "extra": data.extra,
        "valueUnit": "件",
        "name": data.name,
        "value": data.value
      }
    })
  }))])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_c('HomePageCard', {
    staticClass: "recomm-services",
    attrs: {
      "title": "推荐服务"
    }
  }, [_c('div', [_vm._l((_vm.serviceItems), function(data) {
    return [(data.icon !== 'app') ? _c('ServiceItem', {
      key: data.name,
      attrs: {
        "icon": data.icon,
        "name": data.name,
        "desc": data.desc
      },
      nativeOn: {
        "click": function($event) {
          _vm.servicItemClicked(data)
        }
      }
    }) : _vm._e(), _vm._v(" "), (data.icon === 'app') ? _c('Tooltip', {
      key: data.name,
      attrs: {
        "placement": "top"
      }
    }, [_c('ServiceItem', {
      key: data.name,
      attrs: {
        "icon": data.icon,
        "name": data.name,
        "desc": data.desc,
        "delay": 350
      }
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": "//p0.meituan.net/codeman/8acc947084d6b22070523f39dcb7c91428173.png",
        "width": "226px"
      },
      slot: "content"
    })], 1) : _vm._e()]
  })], 2)]), _vm._v(" "), _c('HomePageCard', {
    staticClass: "recomm-actives",
    attrs: {
      "title": "推荐活动"
    }
  }, [(_vm.activeItems && _vm.activeItems.length) ? _c('ul', _vm._l((_vm.activeItems), function(data) {
    return _c('ActiveItem', {
      key: data.id,
      attrs: {
        "name": data.name,
        "date": data.date,
        "bgclass": data.bg
      },
      nativeOn: {
        "click": function($event) {
          _vm.activityItemClicked(data.id)
        }
      }
    })
  })) : _c('div', {
    staticClass: "create-selfpro"
  }, [_c('div', [_c('p', {
    staticClass: "main-desc"
  }, [_vm._v("暂无可参加的活动")]), _vm._v(" "), _c('p', {
    staticClass: "sub-desc"
  }, [_vm._v("自己做促销，同样可以吸引顾客")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createSelfPro
    }
  }, [_vm._v("创建自促活动")])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [_c('div', {
    staticClass: "notices"
  }, [_c('Notices', {
    attrs: {
      "title": "平台公告",
      "notices": _vm.notices
    },
    on: {
      "extraClicked": function($event) {
        _vm.moreNotices(3)
      }
    }
  }), _vm._v(" "), _c('Notices', {
    attrs: {
      "title": "规则中心",
      "notices": _vm.rules
    },
    on: {
      "extraClicked": function($event) {
        _vm.moreNotices(10)
      }
    }
  })], 1), _vm._v(" "), _c('HomePageCard', {
    staticClass: "xigua-academy",
    attrs: {
      "title": "西瓜学院",
      "extra": "更多"
    },
    on: {
      "extraClick": function($event) {
        _vm.moreNotices(5)
      }
    }
  }, [_c('ul', {
    staticClass: "course-list"
  }, _vm._l((_vm.courses), function(courseItem) {
    return _c('CourseItem', {
      key: courseItem.id,
      attrs: {
        "src": courseItem.src,
        "title": courseItem.title,
        "subTitle": courseItem.subTitle
      },
      nativeOn: {
        "click": function($event) {
          _vm.openCourseDetail(courseItem.id)
        }
      }
    })
  }))])], 1), _vm._v(" "), _c('HomePageFooter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63d15468","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/homepage/homepage.vue
// module id = 813
// module chunks = 0